<!-- File Viewer Dialog -->
<p-dialog header="View Attachment" [(visible)]="isVisible" [modal]="true" [style]="{width: '80vw', height: '90vh'}" [maximizable]="true" (onHide)="onClose()">
    <ng-template pTemplate="content">
        <div [ngSwitch]="viewerType" style="height: 100%;">
            <ng-template [ngSwitchCase]="'pdf'">
                <ngx-extended-pdf-viewer [src]="viewerUrl ?? 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf'" height="85vh"></ngx-extended-pdf-viewer>
            </ng-template>
            <ng-template [ngSwitchCase]="'image'">
                <img [src]="viewerUrl" style="max-width: 100%; max-height: 85vh;">
            </ng-template>
            <ng-template [ngSwitchCase]="'office'">
                <iframe [src]="viewerUrl | safeUrl" style="width: 100%; height: 85vh;" frameborder="0"></iframe>
            </ng-template>
            <ng-template ngSwitchDefault>
                <div class="p-3">
                    <p>This file type cannot be previewed.</p>
                    <p>You can still <a [href]="viewerUrl" target="_blank" rel="noopener noreferrer">download the file</a>.</p>
                </div>
            </ng-template>
        </div>
    </ng-template>
</p-dialog>
